'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".ItemImage-module_imageContainer__wv13-{align-items:center;display:flex;height:150px;justify-content:center;position:relative;width:150px}@media screen and (max-width:768px){.ItemImage-module_imageContainer__wv13-{height:96;width:96}}.ItemImage-module_img__iKQcY{height:100%;width:100%}";
var styles = {"imageContainer":"ItemImage-module_imageContainer__wv13-","img":"ItemImage-module_img__iKQcY"};
styleInject["default"](css_248z, 'a393a531-e98a-4fb7-8cac-31de195c5812');

exports["default"] = styles;
